import { Dispatch } from "redux";
import { toast } from "@teamprevent/common/toasts";
import { loadAndTrack } from "redux-request-loading";
import { SUBMIT_QUESTIONNAIRE, submitQuestionnaireSuccess, questionnaireLoaded } from "@teamprevent/common/questionnaires/actions";
import { AnsweredQuestionWithId } from "@teamprevent/common/questionnaires/model";

import { Payload } from "@neworbit/redux-helpers";
import axios from "axios";

import { TasksUpdatedSuccessResult, TaskType, AddTaskModel } from "../task/model";

import * as actions from "./actionTypes";
import { BbvReportApi } from "./BbvReportApi";

export type SubmitBbvReportSuccess = ({ type: typeof actions.SUBMIT_BBV_REPORT_SUCCESS }) & Payload<TasksUpdatedSuccessResult>;
export type BbvReportSuccessorTasksLoadedSuccess = ({ type: typeof actions.BBV_REPORT_SUCCESSOR_TASKS_LOAD_SUCCESS }) & Payload<TaskType[]>;

export const loadBbvReport = buildLoadBbvReport(new BbvReportApi(axios));

export function buildLoadBbvReport(bbvReportApi: BbvReportApi) {
    return (ohCaseId: string, taskId: string, questionnaireKey: string) => {
        return async (dispatch: Dispatch) => {
            const response = await loadAndTrack(dispatch, "loadQuestionnaire", bbvReportApi.load(ohCaseId, taskId));
            if (response) {
                const questions = response.data.questions || [];
                dispatch(questionnaireLoaded({ questions, questionnaireKey }));
            }
        };
    };
}

export const submitBbvReport = buildSubmitBbvReport(new BbvReportApi(axios));

export function buildSubmitBbvReport(bbvReportApi: BbvReportApi) {
    return (ohCaseId: string, taskId: string, questions: AnsweredQuestionWithId[], questionnaireKey: string, tasks: AddTaskModel[]) => {
        return async (dispatch: Dispatch) => {
            const result = await loadAndTrack(dispatch, SUBMIT_QUESTIONNAIRE, bbvReportApi.submit(ohCaseId, taskId, questions, tasks));
            toast.success("BBV report submitted successfully");
            dispatch(submitQuestionnaireSuccess(questionnaireKey));
            dispatch(submitBbvReportSuccess({
                ohCaseId,
                tasks: result
            }));
        };
    };
}

export const loadBbvReportSuccessorTasks = buildLoadBbvReportSuccessorTasks(new BbvReportApi(axios));

export function buildLoadBbvReportSuccessorTasks(bbvReportApi: BbvReportApi) {
    return () => {
        return async (dispatch: Dispatch) => {
            const taskTypes = await loadAndTrack(dispatch, "loadSuccessorTasks", bbvReportApi.loadSuccessorTasks());
            dispatch(loadBbvReportSuccessorTasksSuccess(taskTypes));
        };
    };
}

export function submitBbvReportSuccess(payload: TasksUpdatedSuccessResult): SubmitBbvReportSuccess {
    return {
        type: actions.SUBMIT_BBV_REPORT_SUCCESS,
        payload
    };
}

export function loadBbvReportSuccessorTasksSuccess(payload: TaskType[]): BbvReportSuccessorTasksLoadedSuccess {
    return {
        type: actions.BBV_REPORT_SUCCESSOR_TASKS_LOAD_SUCCESS,
        payload
    };
}
